import { render, staticRenderFns } from "./PmsOrder.vue?vue&type=template&id=4d7ca93e"
import script from "./PmsOrder.vue?vue&type=script&lang=js"
export * from "./PmsOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports